import React from "react";
import { Box, Grid } from "@material-ui/core";

import { Layout, Section } from "../components";

function LaxisApp() {
  return (
    <Layout>
      <Box my={12}>
        <Section>
          <Box className="projectDetails">
            <Box className="banner">Laxis App</Box>
            <Box mt={4} className="title">
              Description
            </Box>
            <Box mt={2}>
              <Box my={1}>
                • Responsible for web application, iOS application and Chrome
                extension with JavaScript, HTML5, CSS3, ReactJS and React
                Native.
              </Box>
              <Box my={1}>
                • Refactored the web application with Material UI and React
                Router, made the application responsive on laptops and tablets,
                built new features that consume RESTful APIs from backend,
                implemented authentication, user management system and other key
                functionalities related to data query and mutation, and improved
                web application performance by 60%.
              </Box>
              <Box my={1}>
                • Fixed bugs and implemented functionalities to support 20
                additional locales and languages on Chrome extension.
              </Box>
              <Box my={1}>
                • Leaded UI design and development of iOS app, refactored
                top-level navigation, rebuilt UI from Figma design, and tested
                latest builds on TestFlight.
              </Box>
              <Box my={1}>
                • Utilized Git and Sourcetree for source control, following
                Agile development methodology and CI/CD workflow. • Launched web
                application with 200 users with a 5% daily growth rate and
                chosen for Google startup company.
              </Box>
            </Box>
            <Box mt={4} className="title">
              Tech Stacks
            </Box>
            <Box mt={1}>
              JavaScript (ES6), TypeScript, HTML5, CSS3, React, React Router,
              Material UI, React Native, Sourcetree, Postman, VS Code
            </Box>
          </Box>
        </Section>
      </Box>
    </Layout>
  );
}

export default LaxisApp;
